import { Button, Card, Group, Radio, Stack, Title } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { TbNumber } from 'react-icons/tb'
import { InputBinary, InputCheckbox, InputNumber, InputRadio } from '../..'

export const DownlinkForm = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Stack>
        <Title order={4}>{t('loraDevices.sendDownlinkMessage')}</Title>
        <InputRadio required name="type" label={t('loraDevices.insertMode')}>
          <Group>
            <Radio value={'2'} label={t('loraDevices.replaceDownlinkQueue')} />
            <Radio value={'1'} label={t('loraDevices.pushToDownlinkQueue')} />
          </Group>
        </InputRadio>
        <Group align={'end'} grow>
          <InputNumber
            style={{ flexGrow: 0 }}
            name="port"
            min={1}
            max={127}
            step={1}
            decimalScale={0}
            label={'Port'}
            required
            icon={TbNumber}
          />
          <InputBinary
            length={32}
            name="payload"
            label={t('loraDevices.payload')}
            required
            maskChar={null}
            icon={TbNumber}
          />
          <Button type="submit" style={{ flexGrow: 0 }} loading={isLoading}>
            {t('generic.send')}
          </Button>
        </Group>
        <InputCheckbox
          name="confirmed"
          label={t('loraDevices.acknowledgeWithUplink')}
        />
      </Stack>
    </Card>
  )
}
